import { createFileRoute } from "@tanstack/react-router";
import { usersListSearchSchema } from "@/features/admin/users/_configs/users-list-search-schema";
import { MembersList } from "@/features/admin/users/list/members-list";

export const Route = createFileRoute("/admin/users/members")({
  validateSearch: usersListSearchSchema,
  component: MembersList,
});
